import HowItWorks from './how-it-works'

export default HowItWorks
